import { makeStyles } from "@material-ui/core/styles";
import backgroungImage from "../../../assets/landingpage_shutterstock_1187511808-blur.jpg";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  landingPageContainer: {
    background: `transparent url(${backgroungImage}) 30% 60% no-repeat`,
    color: "#FFFFFF",
    backgroundSize: "150%",
  },
  applogo: {
    opacity: 1,
    paddingRight: "2em",
    paddingTop: "1em",
    cursor: "pointer",
    float: "right",
    height: "2vw",
    minHeight: 35,
  },
  registerFormGrid: {
    minHeight: 300,
    padding: "5em",
    // paddingLeft: "10em",
    // marginTop: "9vh",
    // [theme.breakpoints.up("md")]: {
    //   marginTop: "5vh",
    // },
    // [theme.breakpoints.down("sm")]: {
    //   paddingLeft: "4em",
    // },
    height: "100vh",
  },
  registerContainer: {
    textAlign: "center",
    width: "100%",
    height: "100%"
  },
  registerCard: {
    paddingTop: "3em",
    paddingLeft: "7em",
    paddingRight: "7em",
    paddingBottom: "3em",
    maxWidth: "1000px",
    marginRight: "auto",
    marginLeft: "auto"
  },
  registerLink: {
    fontSize: "1.2em",
    color: "inherit"
  },
  registerRow: {
    paddingBottom: "1em"
  },
  registerBox: {
    display: "flex",
    justifyContent: "center",
  },
  registerTitle: {
    fontWeight: "bold",
    fontSize: "40px"
  },
  registerHeader: {
    display: "flex",
    justifyContent: "left",
    paddingBottom: "1em",
    fontSize: "40px"
  },
  privacyLink: {
    fontSize: "1.2em",
    color: "inherit",
    paddingLeft: "5px"
  },
  privacyLinkContainer: {
    display: "flex",
    flexDirection: "row",
    textAlign: "left",
    width: "100%",
    marginTop: "-0.9em"
  },
  registerButtons: {
    paddingTop: "0.6em"
  },
  return: {
    backgroundColor: "transparent",
    border: "1px solid black",
    fontSize: "1.2em",
  },
  privacyDialogContent: {
    padding: "1em",
    overflow: "auto"
  },
  privacyDialogTitle: {
    fontWeight: "bold",
    fontSize: "2em"
  },
  privacyHeader: {
    padding: "1em"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "black",
    padding: "2em"
  },
  dialogPaper: {
    maxHeight: "70vh",
    overflow: "scroll",
    padding: "2em",
    paddingBottom: "3em"
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  validTextField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#A0A0A0",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.vaildated.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.vaildated.main,
      },
    },
    "& .MuiFormLabel-root": {
      color: "#767676"
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: theme.palette.vaildated.main,
    },
  },
}), { index: 999 });

export default useStyles;
